import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Constantes from "../../constantes";
import VentanaFlotanteGrupo from "../../componentes/ventanaFlotanteGrupo.js";

function GyC() {
    const [ventanas, setVentanas] = useState([]);
    const [listado_grupos, setListado_Grupos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [busquedaGrupos, setBusquedaGrupos] = useState([]);

    const [textoBusqueda, setTextoBusqueda] = useState("");
    const [cargandoGrupos, setCargandoGrupos] = useState(false);

    const navigate = useNavigate();

    function nombreGrupoA360(nombre) {
        let hash = 0;

        for (let i = 0; i < nombre.length; i++) {
            hash = (hash * 31 + nombre.charCodeAt(i) * 31) >>> 0;
        }

        return hash % 360;
    }

    async function buscarGrupos(nombre) {
        if (!nombre.trim()) {
            setBusquedaGrupos([]);
            return;
        }

        try {
            const respuesta = await fetch(
                Constantes.RUTA_API + '/grupos/buscarGrupo?nombre=' + encodeURIComponent(nombre),
                { method: 'GET', credentials: 'include' }
            );

            const data = await respuesta.json();
            if (!data.error) setBusquedaGrupos(data.grupos);
        } catch (error) {
            console.error('Error al buscar grupos:', error);
        }
    }

    useEffect(() => {
        if (!textoBusqueda.trim()) {
            setBusquedaGrupos([]);
            setCargandoGrupos(false);
            return;
        }
        setCargandoGrupos(true);

        const delay = setTimeout(async () => {

            await buscarGrupos(textoBusqueda);

            setCargandoGrupos(false);
        }, 500);
        return () => clearTimeout(delay);
    }, [textoBusqueda]);



    async function enviarInvitacion(grupoId) {
        try {
            const resultado = await fetch(Constantes.RUTA_API + '/invitaciones/enviarInvitacionGrupo', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ grupoId })
            });
            const data = await resultado.json();
            alert(data.message);
        } catch (error) {
            console.error('Error al enviar la invitación:', error);
        }
    }

    const abrirVentana = (grupo) => {
        console.log("Abriendo ventana para grupo:", grupo);
        const existe = ventanas.find((v) => v.id === grupo.grupo_id);
        if (existe) return;
        setVentanas((prev) => [
            ...prev,
            { id: grupo.grupo_id, nombre: grupo.nombre, color: `hsl(${nombreGrupoA360(grupo.nombre)}, 70%, 80%)`, z: prev.length + 1 }
        ]);
    };

    const cerrarVentana = (id) => {
        setVentanas((prev) => prev.filter((v) => v.id !== id));
    };

    const focusVentana = (id) => {
        setVentanas((prev) => {
            const maxZ = prev.length ? Math.max(...prev.map(v => v.z)) : 0;
            return prev.map(v => v.id === id ? { ...v, z: maxZ + 1 } : v);
        });
    };

    useEffect(() => {
        async function fetchSolicitudes() {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/miembros_grupos/solicitudesPendientes', {
                    method: 'GET',
                    credentials: 'include'
                });
                const data = await respuesta.json();
                if (!data.error) {
                    console.log('Solicitudes pendientes:', data.solicitudes);
                }
            } catch (error) {
                console.error('Error al obtener las solicitudes pendientes:', error);
            }
        }
        fetchSolicitudes();
    }, []);

    useEffect(() => {
        async function fetchGrupos() {
            try {
                const respuesta = await fetch(Constantes.RUTA_API + '/miembros_grupos/misGrupos', {
                    method: 'GET',
                    credentials: 'include'
                });
                const data = await respuesta.json();
                if (!data.error) {
                    setListado_Grupos(data.grupos);
                }
            } catch (error) {
                console.error('Error al obtener los grupos:', error);
            }
        }
        fetchGrupos();
    }, []);


    const gruposFiltrados = listado_grupos.filter(g =>
        g.nombre.toLowerCase().includes(busqueda.toLowerCase())
    );

    return (
        <>
            <div className="App d-flex bg-dark text-white justify-content-center row marginLess" style={{ overflow: "hidden", boxSizing: "border-box" }}>
                <div className="col-md-2 col-sm-12 paddingLess" style={{ display: "flex", flexDirection: "column", height: "100%", boxSizing: "border-box" }}>
                    <div style={{ backgroundColor: "black", overflowY: "auto", flex: 1, boxSizing: "border-box" }}>
                        <h5 style={{ padding: "5px", margin: 0, boxSizing: "border-box" }}>Mis grupos</h5>
                        <input
                            type="text"
                            placeholder="Buscar grupo..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                            style={{
                                width: "calc(100% - 20px)",
                                padding: "8px 10px",
                                borderRadius: "5px",
                                border: "none",
                                margin: "5px 10px",
                                height: "35px",
                                boxSizing: "border-box"
                            }}
                        />

                        <button
                            key="crearGrupo"
                            onClick={() => navigate('/crearGrupo')}
                            style={{ display: "block", margin: "5px 10px", borderRadius: "8px", width: "calc(100% - 20px)", padding: "5px", boxSizing: "border-box" }}
                        >Crear grupo</button>

                        {gruposFiltrados.map((grupo) => (
                            <>
                                <div className="d-flex justify-content-between align-items-center" style={{
                                    width: "100%",
                                    padding: "5px",
                                    borderRadius: "5px"
                                }}>

                                    <button
                                        key={grupo.grupo_id + "open"}
                                        onClick={() => abrirVentana(grupo)}
                                        style={{ display: "block", margin: "5px", borderRadius: "8px" }}
                                    >
                                        Abrir grupo {grupo.nombre}
                                    </button>
                                    <button
                                        key={grupo.grupo_id + "config"}
                                        onClick={() => navigate('/ConfiguracionGrupo/' + grupo.grupo_id)}
                                        style={{ display: "block", margin: "5px", borderRadius: "8px" }}
                                    >⚙</button>
                                </div>
                            </>
                        ))}
                    </div>


                </div>

                <div className="col-md-10 col-sm-12 paddingLess" style={{ display: "flex", flexDirection: "column", height: "100%", boxSizing: "border-box" }}>
                    <h5 style={{ padding: "5px 10px", margin: 0, boxSizing: "border-box" }}>Buscar grupos</h5>
                    <input
                        type="text"
                        placeholder="Buscar grupos..."
                        value={textoBusqueda}
                        onChange={(e) => setTextoBusqueda(e.target.value)}
                        style={{
                            margin: "5px 10px",
                            padding: "8px",
                            borderRadius: "5px",
                            border: "none",
                            height: "35px",
                            boxSizing: "border-box"
                        }}
                    />


                    <div style={{ overflowY: "auto", flex: 1, boxSizing: "border-box" }}>
                        {cargandoGrupos && <p className="text-center">Cargando grupos...</p>}
                        {!cargandoGrupos && busquedaGrupos.length === 0 && (
                            <p className="text-center">No se ha encontrado ningún grupo con ese nombre.</p>
                        )}
                        {!cargandoGrupos && busquedaGrupos.length > 0 && (
                            <ul className="list-unstyled">
                                {busquedaGrupos.map((grupo) => {
                                    return (
                                        <li key={grupo.id} className="mb-3 p-3 border rounded shadow-sm">
                                            <div className="d-flex justify-content-between align-items-center"
                                            >
                                                <strong>Grupo: {grupo.nombre}</strong>

                                                <button className="btn btn-success btn-sm" onClick={() => enviarInvitacion(grupo.id)}>enviar solicitud</button>

                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>

                {ventanas.map((v) => (
                    <VentanaFlotanteGrupo
                        key={v.id}
                        id={v.id}
                        nombre={v.nombre}
                        color={v.color}
                        z={v.z}
                        onClose={() => cerrarVentana(v.id)}
                        onFocus={() => focusVentana(v.id)}
                    />
                ))}
            </div>

            <title>Grupos y comunidades</title>
        </>
    );
}

export default GyC;
